import axios from "axios";
import { IFlightExchangePolicyRes } from "redmond";

import { config } from "../../config";
import {
  fetchFlightExchangeEligibilityQuotePath,
} from "../paths";

const fetchFlightExchangePolicyV2 = (
  itineraryId: string,
): Promise<IFlightExchangePolicyRes> =>
  new Promise(async (resolve, reject) => {
    try {
      const reservationId = itineraryId;
      const req = { reservationId };
      const res = await axios.post(fetchFlightExchangeEligibilityQuotePath, req, {
        baseURL: config.baseURL,
      });

      if (res.data.AirExchangeEligibilityQuoteResponse === "AirExchangeEligibilityQuoteSuccess") {
        resolve(res.data.exchangeScenario);
      } else {
        reject(res.data.error);
      }

    // mock fetch load time & response
    // setTimeout(reject, 2500);
    } catch (e) {
      reject(e);
    }
  });

export default fetchFlightExchangePolicyV2;
